import ModuleContainer from './ModuleContainer';

export default ModuleContainer;
